var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { AvailablePopover } from '../../../../components/other/AvailablePopover';
let MenubarIconStatistic_ = class MenubarIconStatistic_ extends React.PureComponent {
    get menubarRight() {
        return this.props.app.menubar.menubarRight;
    }
    render() {
        const { app } = this.props;
        return null;
        return (React.createElement(React.Fragment, null,
            React.createElement(AvailablePopover, { content: React.createElement("span", { style: { fontWeight: 500, fontSize: 14 } }, "Deine Statistiken"), overlayStyle: { paddingTop: 0 }, placement: "bottom", visible: this.menubarRight.isStatisticIconHovering },
                React.createElement("a", { href: "/statistik", className: "MenubarRightIconButton", onMouseEnter: action(() => {
                        this.menubarRight.isStatisticIconHovering = true;
                    }), onMouseLeave: action(() => (this.menubarRight.isStatisticIconHovering = false)) },
                    React.createElement("i", { className: "fas fa-chart-line" })))));
    }
};
MenubarIconStatistic_ = __decorate([
    observer
], MenubarIconStatistic_);
export { MenubarIconStatistic_ };
